import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Reveal } from '@/components/Reveal';
import { useLang } from '@/i18n/LangContext';

export const FaqAccordion = ({ items, eyebrow, title, id = 'faq' }) => {
  const { t } = useLang();
  const resolvedEyebrow = eyebrow === undefined ? t('faqTitle') : eyebrow;
  const resolvedTitle = title === undefined ? t('faqTitle') : title;
  return (
  <section id={id} data-testid="faq-section" className="scroll-mt-28">
    <div className="max-w-3xl">
      {resolvedEyebrow && <p className="text-xs uppercase tracking-[0.25em] font-semibold text-primary mb-4">{resolvedEyebrow}</p>}
      {resolvedTitle && <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mb-8">{resolvedTitle}</h2>}
    </div>
    <Reveal>
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {items.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-b border-border">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-heading text-base md:text-lg font-semibold py-5 hover:text-primary hover:no-underline transition-colors duration-150">
              {item.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="text-base leading-relaxed text-foreground/70 pb-6 max-w-3xl">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
  );
};
